import { render } from "./QuranJuzCard.vue?vue&type=template&id=11e5e11a"
import script from "./QuranJuzCard.vue?vue&type=script&lang=js"
export * from "./QuranJuzCard.vue?vue&type=script&lang=js"
script.render = render

export default script